import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Select, Button, Modal } from "antd";
import Autocomplete from "react-google-autocomplete";
import { CaretDownOutlined } from "@ant-design/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import DiscoverModal from "./DiscoverModal";
import { filterActions } from "store-redux/filter-slice";
import { GOOGLE_MAP_API_KEY } from "../../../configs/AppConfig";

import classes from "./WelcomingBanner.module.css";
import useWindowWidth from "helpers/useWindowWidth";
import { NavigationContext } from "App";
import { pincodefetch } from "hooks/pincodeFetch";

const proximityValues = [
  { label: "Within 5 km", value: 5 },
  { label: "Within 10 km", value: 10 },
  { label: "Within 20 km", value: 20 },
  { label: "Within 50 km", value: 50 },
  { label: "Within 75 km", value: 75 },
];

const WelcomingBanner = ({ data }) => {
  const { Option } = Select;
  const location = useSelector((state) => state.filter);
  const user = useSelector((state) => state.user.user);
  const width = useWindowWidth();
  const { homeApis } = useSelector((state) => state.widgets); // Access widget data

  const [locationSelected, setLocationSelected] = useState();
  const [filterData, setFilterData] = useState({
    range: undefined,
    vendorId: undefined,
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsBackNavigation } = useContext(NavigationContext);

  useEffect(() => {
    localStorage.removeItem("wedding_filter");
  }, []);

  const filterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  // useEffect(() => {
  //   if (locationSelected) {
  //     setFilterData({
  //       ...filterData,
  //       latitude: locationSelected.latitude,
  //       longitude: locationSelected.longitude,
  //     });
  //   }
  // }, [locationSelected]);

  const constructQueryString = (filterData) => {
    const queryParams = [];
    for (const key in filterData) {
      if (filterData[key] !== "" && filterData[key] !== undefined) {
        queryParams.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(filterData[key])}`
        );
      }
    }
    return queryParams.join("&");
  };

  const handleClick = () => {
    if (locationSelected) {
      dispatch(
        filterActions.togglelocation({
          latitude: locationSelected?.latitude,
          longitude: locationSelected?.longitude,
          address: locationSelected?.address,
          place: locationSelected?.place,
          pincode: locationSelected?.pincode,
        })
      );
    }

    const queryString = constructQueryString(filterData);
    navigate(queryString ? `/search?${queryString}` : "/search");
    // navigate('/search');
    localStorage.setItem("wedding_filter", JSON.stringify(filterData));
  };

  console.log("location selected rrr", locationSelected);

  const locationFinder = async (place) => {
    if (place.geometry && place.geometry.location) {
      const latitude = place.geometry.location.lat();
      const longitude = place.geometry.location.lng();

      const pincode = await pincodefetch(latitude, longitude);
      // const formattedAddress = place.formatted_address;
      // const placeName = place.address_components[0]?.long_name;
      const formattedAddress = `${place?.name},${place?.formatted_address}`;
      const placeName = place?.name;

      setLocationSelected({
        latitude,
        longitude,
        address: formattedAddress,
        place: placeName,
        pincode: pincode,
      });
    }
  };

  // const sessionStore = location?.pathname?.includes("/branch")
  //   ? "branches"
  //   : location?.pathname?.includes("online-consultation")
  //   ? "online-consultation"
  //   : "home";

  const sessionStore = "home";

  return (
    <>
      <div className={`${classes.welcomebannerDiv} wmb`}>
        {/* Swiper Carousel */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          pagination={{ clickable: true }}
          allowTouchMove={true}
          grabCursor={true}
          className={`${classes.bannerSwiper} banner-swiper`}
        >
          {data?.listingItems?.map((src, index) => (
            <SwiperSlide key={index} className={classes.swiperSlide}>
              <div className={classes.bannerContentWrapper}>
                {width < 950 && (
                  <div className={classes.mobileContent}>
                    {/* <div className={classes.overLayIn}> */}
                    {/* <div className={classes.overLay}></div> */}
                    <h1>{src?.name}</h1>
                    <p>{src?.description}</p>
                    {/* </div> */}
                    <Button onClick={() => setIsModalVisible(true)}>
                      Discover
                    </Button>
                  </div>
                )}
                <img
                  src={width > 1200 ? src.image : src.mobileImage}
                  className={classes.bannerImg}
                  alt={`banner-${index}`}
                />
                <div className={classes.bannerText}>
                  <div className={classes.textDiv}>
                    <h1>{src?.name}</h1>
                    <p>{src?.description}</p>
                    {/* <div className={classes.overLay}></div> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Search & Discover Section */}
        <div className={classes.filterDiv}>
          <h2>Discover Dreamy Venues & More!</h2>

          <div className="autocomplete-div">
            <Autocomplete
              className="banner-location"
              onPlaceSelected={locationFinder}
              style={{ width: "100%", boxSizing: "border-box" }}
              // onChange={(e) => setSelectedAddress(e.target.value)}
              placeholder="Enter a Location"
              apiKey={GOOGLE_MAP_API_KEY}
              options={{
                // Try searching all place types, not just addresses
                types: ["establishment", "geocode"], // Use 'establishment' to include businesses like "Lulu"
                fields: [
                  "name",
                  "formatted_address",
                  "geometry",
                  "address_components",
                  "place_id",
                  "vicinity",
                ], // 👈 ADD THIS
                componentRestrictions: { country: "in" }, // restrict to India or your country
              }}
            />
            <CaretDownOutlined className={"dropdown-arrow"} />
          </div>
          <Select
            showSearch
            onChange={(value) => filterDataChange("eventType", value)}
            placeholder="Event Type"
            style={{ width: "100%", height: "50px" }}
            className="event-select"
            suffixIcon={
              <CaretDownOutlined
                className={"dropdown-arrow"}
                style={{ paddingRight: "6px" }}
              />
            }
          >
            {homeApis?.eventType?.map((option) => (
              <Option key={option?.slug} value={option?.slug}>
                {option?.name}
              </Option>
            ))}
          </Select>
          <Button
            className={classes.filterButton}
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              setIsBackNavigation(true);
              handleClick();
            }}
          >
            Search
          </Button>
        </div>
      </div>

      {/* Discover Modal */}
      <Modal
        title=""
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        closable={false}
        width={width < 540 ? "90vw" : "450px"}
      >
        <DiscoverModal
          proximityValues={proximityValues}
          // categoryData={categoryData}
          // vendorList={vendorList}
          filterData={filterData}
          handleClick={handleClick}
          filterDataChange={filterDataChange}
          locationFinder={locationFinder}
          eventTypes={homeApis?.eventType}
        />
      </Modal>
    </>
  );
};

export default WelcomingBanner;
